<template>
  <panel v-if="schemaReady" :title="title">
    <attachments
      :schema="$schema"
      :entity-type="entityType"
      :entity-id="entityId"
      :show-radio="showRadio"
      :editable="editable"
      :use-index-as-order="useIndexAsOrder"
      :show-add-from-mdok-button="true"
      @errors="emitErrors"
    />

    <div v-if="validated && validateAttachments">
      <div v-for="(error, index) in errors" :key="'error_' + index" class="py-2 text-warning">
        {{ error.$validateResult.message }}
      </div>
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Attachments from '@/components/formComponents/attachment/Attachments';
import Panel from '@/components/panel/Panel';
import { EntityType } from '@/enums/entityType.enum';
import { Options } from '@/enums/options.enum';
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/documentAttachments.schema';

// @vuese
// Załączniki wniosku
// @group Document
export default {
  components: { Attachments, Panel },
  mixins: [formMixin],
  schema,
  props: {
    // Czy pokazywać pytanie "Czy chcesz dodać załączniki"
    showRadio: { type: Boolean, default: false },
    // Czy można edytować załączniki
    editable: { type: Boolean, default: false },
    // Czy zwalidowany formularz
    validated: { type: Boolean, required: false, default: false },
    // Lista załączników
    attachments: { type: Array, default: () => [] },
    // Tytuł
    title: { type: String, required: false },
    // Wymuś poprawne numerowanie - blokuje możliwość zmiany kolejności
    useIndexAsOrder: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      entityType: EntityType.DOCUMENT,
      entityId: this.$route.params.documentId.toString(),
      model: {},
      errors: [],
      schemaReady: false
    };
  },
  computed: mapState({
    validateAttachments: state => state.optionValue.options[Options.VALIDATE_ATTACHMENTS]?.value === 'true'
  }),
  mounted() {
    this.setValidationMessage(this.showRadio);
    this.$schema.attachments.$setData(this.attachments);
  },
  methods: {
    // @vuese
    // Emitowanie błędów w załącznikach
    emitErrors(val) {
      if (this.validateAttachments) {
        this.errors = [...val];
        this.$emit('errors', val);
      }
    },

    // @vuese
    // Ustawia wiadomość walidacyjną
    setValidationMessage() {
      this.schemaReady = false;
      if (this.showRadio) {
        schema.properties.attachments.warnings.warningMessages.minItems =
          'Dołącz załącznik, a jeśli nie chcesz dołączyć załącznika zmień wybór w części wniosku „Czy chcesz dodać załącznik”.';
      } else {
        schema.properties.attachments.warnings.warningMessages.minItems = 'Załącznik nie został dołączony.';
      }
      this.$setSchema(schema);
      this.schemaReady = true;
    }
  }
};
</script>
